import { Box, Stack, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";

interface IProps {
  title: string;
  description: string;
  onView: () => void;
}

const ReportCard = ({ title, description, onView }: IProps) => {
  const { t } = useTranslation("reports");

  return (
    <Box
      onClick={onView}
      sx={{
        p: 3,
        height: 170,
        border: "1px solid",
        borderColor: "#E4E7EC",
        borderRadius: 4,
        cursor: "pointer",
        bgcolor: "#FFF",
        transition: "all .25s ease",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",

        "&:hover": {
          borderColor: "primary.main",
          boxShadow: "0 10px 30px rgba(16,24,40,.08)",
        },

        "&:hover .report-description": {
          opacity: 1,
          transform: "translateY(0)",
        },
      }}
    >
      <Stack spacing={1}>
        <Typography fontSize={18} fontWeight={600} color="text.primary">
          {title}
        </Typography>

        <Typography
          className="report-description"
          variant="body2"
          color="text.secondary"
          sx={{
            opacity: 0,
            transform: "translateY(6px)",
            transition: "all .25s ease",
            lineHeight: 1.6,
          }}
        >
          {description}
        </Typography>
      </Stack>

      <Stack
        direction="row"
        spacing={0.5}
        alignItems="center"
        sx={{
          color: "primary.main",
          fontWeight: 600,
        }}
      >
        <Typography fontWeight={600}>{t("view")}</Typography>

        <ArrowForwardIcon fontSize="small" />
      </Stack>
    </Box>
  );
};

export default ReportCard;
